import { useEffect } from "react";
import {
  Drawer,
  Stack,
  Typography,
  Toolbar,
  Box
} from "@mui/material";
import { useIsDesktopLayout } from "../../../hooks/useIsDesktopLayout";
import Workspaces from "./components/Workspaces";

export interface SideNavigationProps{
  open: boolean,
  width?: number,
  onChange: (open: boolean) => void
}

const SideNavigation = ({width = 250, open, onChange}: SideNavigationProps) => {

  const isMediumScreen = useIsDesktopLayout();
  // Sync drawer open-state to the breakpoint only when it actually flips;
  // onChange is a caller-owned prop and must not retrigger this effect.
  useEffect(() => {
    if(isMediumScreen) onChange(true)
    else onChange(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMediumScreen]);

  return(
    <Drawer 
      open={open} 
      variant={isMediumScreen ? 'persistent' : 'temporary'} 
      sx={{ 
        [`& .MuiDrawer-paper`]: { 
          width: width, 
          boxSizing: 'border-box', 
          height: "100%", 
          borderRadius: 0, 
          borderRight: 'none'
        },
        pointerEvents: isMediumScreen || open ? 'auto' : 'none',
      }}
      onClose={() => onChange(false)}
    >
      <Stack maxHeight="100%" height='100%'>
        <Toolbar />
        
        <Box flex={1} overflow='auto' pt={2}>
          <Workspaces />
        </Box>
        
        <Stack px={2} py={1}>
          <Typography variant="caption">Powered By:</Typography>
          <Typography variant="caption">Thynker Technologies Inc.</Typography>
        </Stack>
        
      </Stack>
    </Drawer>
  )
};


export default SideNavigation;
